import _ from 'lodash';

function userHasTariffActions(userGroups) {
  return _.intersection(['all', 'tariff_actions'], userGroups).length > 0;
}

function userHasBillingActions(userGroups) {
  return _.intersection(['all', 'billing_actions'], userGroups).length > 0;
}

export const permissions = {
  userHasTariffActions,
  userHasBillingActions,
};



// WEBPACK FOOTER //
// ./src/libs/permissions.js